import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as PdfIcon } from "../../../assets/resporting/PdfIcon.svg";
import { ReactComponent as sendIcon } from "../../../assets/resporting/sendIcon.svg";
import { ReactComponent as Ascore } from "../../../assets/ecoscore/LeafA.svg";
import ScoreCircle from "./../../Components/ScoreCircle";
import { ReactComponent as Cross } from "../../../assets/analyse/Cross.svg";

import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { setAnalysisId } from "../../../redux/actions/analysisActions";
import { fetchOptimization, removeOptimization, removeOptimizationLocal } from "../../../redux/actions/optimizationActions";
import { setNewComHistory } from "../../../redux/actions/comActions";
import { fetchAnalysis, removeAnalysis, removeAnalysisLocal } from "../../../redux/actions/analysisActions";
import { useNavigate } from "react-router-dom";

import useTable from "../../Components/useTable";
import TableFooter from "../../Components/TableFooter";
import MainButton from "../../../commonComponents/MainButton";
import Modal from "react-modal";
import { ListItemButton } from "@mui/material";
import { Database } from "firebase/database";
import { v4 as uuid } from "uuid";


const ReportTable = ({ all_history, navigate_to, all_history_filtrer, rand_update, set_rand_update }) => {
  const navigate = useNavigate();
  const [isDelete, setIsDelete] = useState(false);
  const [toDelete, setToDelete] = useState(null);

  // REDUX
  const dispatch = useDispatch();
  const setAnalysisId_rd = (item) => dispatch(setAnalysisId(item));
  const setNewComHistory_rd = (item) => dispatch(setNewComHistory(item));

  const user_info = useSelector((state) => (state.user.user_info ? state.user.user_info : null));

  /////////////////////// OPTIMIZATION ///////////////////////
  const fetchOptimization_rd = (item) => dispatch(fetchOptimization(item));
  const removeOptimization_rd = (item) => dispatch(removeOptimization(item));
  const removeOptimizationLocal_rd = (item) => dispatch(removeOptimizationLocal(item));

  /////////////////////// ANALYSIS ///////////////////////
  const fetchAnalysis_rd = (item) => dispatch(fetchAnalysis(item));
  const removeAnalysis_rd = (item) => dispatch(removeAnalysis(item));
  const removeAnalysisLocal_rd = (item) => dispatch(removeAnalysisLocal(item));

  const handleChangeRemove = async (item) => {
    if (item.slice(0, 3) === "opt") {
      removeOptimization_rd(item);
      removeOptimizationLocal_rd(item);
      setIsDelete(false);
      set_rand_update(Math.random());
    } else if (item.slice(0, 3) === "anl") {
      removeAnalysis_rd(item);
      removeAnalysisLocal_rd(item);
      setIsDelete(false);
      set_rand_update(Math.random());
    }
  };

  const handleChangeModify = async (item) => {
    console.log("MOD");
    if (item.slice(0, 3) === "opt") {
      await setAnalysisId_rd(item);
      // await fetchAnalysis_rd(item);
      await fetchOptimization_rd(item.slice(4));

      navigate("/" + navigate_to, {
        state: { history: true },
      });
    } else if (item.slice(0, 3) === "anl") {
      await setAnalysisId_rd(item);
      await fetchAnalysis_rd(item);

      navigate("/" + navigate_to, {
        state: { history: true },
      });
    }
  };

  async function write_com_history(item, data) {
    const com_id = item.slice(4);
    const com_history_data = {
      // type: "communication",
      // active_users: x[1].active_users,
      // type: item.slice(0, 3) === "anl" ? "analyse" : "optimisation",
      type: navigate_to === "EcoKit" ? "Kit communication" : "Rapport d'analyse",
      createdAt: new Date().toLocaleString("en"),
      eco_score: data.eco_score,
      product_name: data.product_name,
      // ref: "com_" + com_id + (navigate_to === "EcoKit" ? "kit_com" : "rapport"),
      ref: "com_" + uuid(),
      analysis_id: com_id
      // status: x[1].status,
    };
    await setNewComHistory_rd(com_history_data);
  }

  const handleChangeGenReport = async (item, data) => {
    console.log("MOD", item.slice(4), data);

    // WRITE COM HISTORY
    // com history data modal

    // go to next page
    if (item.slice(0, 3) === "opt") {
      await setAnalysisId_rd(item.slice(4));
      await fetchOptimization_rd(item.slice(4));
      await write_com_history(item, data);
      // navigate("/Report", {
      navigate("/" + navigate_to, {
        state: { type: "optimization" },
      });
    } else if (item.slice(0, 3) === "anl") {
      await setAnalysisId_rd(item.slice(4));
      await fetchAnalysis_rd(item.slice(4));
      await write_com_history(item, data);
      // navigate("/Report", {
      navigate("/" + navigate_to, {
        state: { type: "analyse" },
      });
    }
  };

  // data slicing
  const [page, setPage] = useState(1);
  const rowsPerPage = 5;
  // const [rand_update, set_rand_update] = useState(null);
  const { slice, range } = useTable(Object.entries(all_history), page, rowsPerPage, all_history_filtrer, rand_update);

  const getStatusStyle = (value) => {
    switch (value) {
      case "onGoing":
        return "bg-purple-200 text-purple-600 py-1 px-3 rounded-full text-xs";
      case "completed":
        return "bg-green-200 text-green-600 py-1 px-3 rounded-full text-xs";
      default:
        return;
    }
  };
  const getStatusName = (value) => {
    switch (value) {
      case "onGoing":
        return "En cours";
      case "completed":
        return "Terminée";
      default:
        return;
    }
  };
  const getTypeStyle = (value) => {
    switch (value) {
      case "analyse":
        return "bg-[#C6EDDF] text-[#169A6A] py-1 px-3 rounded-full text-xs";
      case "optimisation":
        return "bg-[#CEE3FF] text-[#0448A5] py-1 px-3 rounded-full text-xs";
      default:
        return;
    }
  };
  const getTypeName = (value) => {
    switch (value) {
      case "analyse":
        return "analyse";
      case "optimisation":
        return "optimisation";
      default:
        return;
    }
  };

  return (
    <>
      <div className="overflow-x-auto">
        <div className="min-w-screen bg-gray-100 flex items-center justify-center bg-gray-100 font-Poppins-SemiBold overflow-hidden">
          <div className="w-full mr-[95px] ml-[150px]">
            <div className="bg-white shadow-md rounded my-6">
              <table className="min-w-max w-full table-auto">
                <thead>
                  <tr className="bg-gray-200 text-gray-600 uppercase text-sm leading-normal">
                    <th className="py-3 px-6 text-left">Référence</th>
                    <th className="py-3 px-6 text-left">Nom du produit</th>
                    <th className="py-3 px-6 text-center">Type</th>
                    <th className="py-3 px-6 text-center">Score EF</th>
                    <th className="py-3 px-6 text-center">Date de création</th>
                    <th className="py-3 px-6 text-center">Status</th>
                    {/* <th className="py-3 px-6 text-center">Intervenants</th> */}
                    {/* {navigate_to !== "ReduceParametersChoice" && <th className="py-3 px-6 text-center">Actions</th>} */}
                  </tr>
                </thead>

                {all_history &&
                  Object.values(all_history).length > 0 &&
                  slice &&
                  Object.values(slice).map((value, i) => {
                    return (
                      <tbody key={i} className="text-gray-600 text-sm font-light">
                        <tr
                          onClick={async () => {
                            handleChangeGenReport(value[0], value[1]);
                          }}
                          className={`border-b border-gray-200 hover:bg-gray-100 ${navigate_to !== "ReduceParametersChoice" ? "" : "cursor-pointer"}`}
                        >
                          <td className="py-3 pl-6 text-left whitespace-nowrap">
                            <div className="flex items-center w-[100px]">
                              <span className="font-medium overflow-hidden text-ellipsis">{value[0]}</span>
                            </div>
                          </td>

                          <td className="py-3 pl-6 text-left whitespace-nowrap">
                            <div className="flex items-center w-[210px] ">
                              <span className="font-medium overflow-hidden text-ellipsis">{value[1].product_name}</span>
                            </div>
                          </td>

                          <td className="py-3 px-6 text-center justify-center">
                            <span className={getTypeStyle(value[1].type)}>{getTypeName(value[1].type)}</span>
                          </td>

                          <td className="py-3 px-6 whitespace-nowrap justify-center">
                            <div className="justify-center items-center ml-[31px] h-[60px] w-[60px]">
                              <ScoreCircle score={value[1].eco_score} />
                            </div>
                          </td>

                          <td className="py-3 px-6 text-center">
                            <div className="items-center">
                              <span>{value[1].createdAt}</span>
                            </div>
                          </td>

                          <td className="py-3 px-6 text-center">
                            <span className={getStatusStyle(value[1].status)}>{getStatusName(value[1].status)}</span>
                          </td>

                          {/* <td className="py-3 px-6 text-center">
                            <div className="flex items-center justify-center">
                              <img className="w-6 h-6 rounded-full border-gray-200 border transform hover:scale-125" src="https://randomuser.me/api/portraits/men/1.jpg" />
                              <img className="w-6 h-6 rounded-full border-gray-200 border -m-1 transform hover:scale-125" src="https://randomuser.me/api/portraits/women/2.jpg" />
                              <img className="w-6 h-6 rounded-full border-gray-200 border -m-1 transform hover:scale-125" src="https://randomuser.me/api/portraits/men/3.jpg" />
                            </div>
                          </td> */}

                          {/* {navigate_to !== "ReduceParametersChoice" && (
                            <td className="py-3 px-6 text-center">
                              <div className="flex item-center justify-center"> */}
                          {/* SEE */}
                          {/* <div className="w-4 mr-2 transform hover:text-purple-500 hover:scale-110">
                                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth="2"
                                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                    />
                                  </svg>
                                </div> */}
                          {/* MODIFY */}
                          {/* <div
                                  onClick={async () => {
                                    handleChangeModify(value[0]);
                                  }}
                                  className="w-4 mr-2 transform hover:text-purple-500 hover:scale-110"
                                >
                                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth="2"
                                      d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                                    />
                                  </svg>
                                </div> */}
                          {/* DELETE */}
                          {/* <div
                                  onClick={() => {
                                    console.log("DELTE");
                                    setToDelete(value[0]);
                                    setIsDelete(true);
                                  }}
                                  className="w-4 mr-2 transform hover:text-purple-500 hover:scale-110"
                                >
                                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth="2"
                                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                    />
                                  </svg>
                                </div> */}
                          {/* </div>
                            </td>
                          )} */}
                        </tr>
                      </tbody>
                    );
                  })}
              </table>

              {all_history && Object.values(all_history).length === 0 && (
                <div className={"grid place-items-center py-[140px]"}>
                  <p className="font-Poppins-SemiBold">Aucune analyse ou optimisation trouvées. Créez-en !</p>
                  <div class="flex items-center w-[200px] justify-center mt-8 h-[40px]">
                    <MainButton disabled={user_info.organization_info.role.access.communicate.write} title={"Créer une analyse"} callback={async () => navigate("/AnalysisProduceChoice")} />
                  </div>
                </div>
              )}

              {all_history && slice && Object.values(all_history).length > 0 && <TableFooter range={range} slice={Object.entries(slice)} setPage={setPage} page={page} />}

              <Modal
                isOpen={isDelete}
                onBackdropPress={() => setIsDelete(false)}
                style={{
                  content: {
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: 330,
                    width: 580,
                    borderRadius: 20,
                    borderWidth: 0,
                    boxShadow: "0px 0px 2px #9E9E9E",
                  },
                }}
              >
                <div className=" h-full grid justify-items-center">
                  <p className="font-Poppins-SemiBold text-4xl flex text-center mt-[50px]">Supprimer l'analyse {toDelete && toDelete[1].product_name} ?</p>
                  <div className="cursor-pointer absolute right-2">
                    <Cross height={20} onClick={() => setIsDelete(false)} />
                  </div>
                  <div class="flex items-center w-[200px] justify-center h-[40px] mt-[-30px]">
                    <MainButton disabled={true} callback={async () => await handleChangeRemove(toDelete)} title={"Supprimer"} styleWind={"text-xs px-[10px]"} />
                  </div>
                </div>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReportTable;
